<div class="header-soundtracks grid-center-column-items justify-between">
  <p>Select a category</p>
  <button (click)="openEditCategoriesDialog()">
    <span> Edit </span>
  </button>
</div>
